import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux"
import PageHeader from '../../components/common/PageHeader';
import AccountSettingTab from './AccountSettingTab';
import PlanInfoHeader from './AccountSettingTab/PlanInfoHeader';
import { get, cancel } from "../../context/actions/subscription"
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import './index.scss';
const MySwal = withReactContent(Swal)
const AccountSetting = () => {

    const dispatch = useDispatch();
    const [plan, setPlan] = useState('')
    const [trans, setTrans] = useState({})

    useEffect(() => {
                if (!plan)
            subscription()

    })

    /**
     * @description method call subscription details
     */
    const subscription = (param = {}) => {
        dispatch(get(param, (res) => {
            if (res?.subscription) {
                setPlan(res?.subscription)
                setTrans(res?.transaction)
            }
        }))
    }

    /**
   * @description method call subscription details
   */
    const cancelSubscription = () => {

        MySwal.fire({
            title: 'Are you sure?',
            text: "You want to cancel subscription",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel it!'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(cancel((res) => {
                    setPlan(res)
                }))
                MySwal.fire(
                    'Cancelled!',
                    'Your subscription has been cancelled.',
                    'success'
                )
            }
        })
    }

    return (
        <>
            <div className="page-wrapper">
                <PageHeader className='account-setting-head'>
                    <div className="left-col">
                        Account Settings
                    </div>
                    <div className="right-col ms-auto">
                        <PlanInfoHeader _plan={plan} _cancel={cancelSubscription} />
                    </div>
                </PageHeader>
                <div className="inner-wrapper">
                    <div className="account-setting-wrapper">
                        <AccountSettingTab _plan={plan} _trans={trans} _subscription={subscription} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default AccountSetting;